module.exports = __webpack_public_path__ + "img/3.a6c58936.png";